/* eslint-disable no-undef */
import axios from "axios";
import { Message } from "@arco-design/web-react";
import { getTokenToLocalStorage } from "@/utils/token";
import qs from "qs";
import publishStore from '@/stores/publishStore';
import { whiteListRequest } from "@/config/whiteLIst";
// 需要跳过 Token 校验的路由

const http = axios.create({
  // baseURL:
  //   process.env.REACT_APP_MODE === "development"
  //     ? ""
  //     : process.env.REACT_APP_PROXY,
  baseURL: "/api/v1",
  timeout: 100000,
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    const requestUrl = config.url;
    console.log(config.url);
    config.headers["AID"] = publishStore.aid;
    const token = getTokenToLocalStorage();
    const currentPath = window.location.pathname + window.location.search;
    // if (requestUrl === "/user/login") {
    //   config.headers["Device"] = "web_client"
    //   return config;
    // }
    const isWhitelisted = whiteListRequest.some((route) => {
      return route === requestUrl;
    });
    // 跳过 Token 验证和头部附加
    if (isWhitelisted) {
      if (window.electron) {
        config.headers["Device"] = "web_client";
      }
      return config;
    }
    if (!token) {
      window.location.href = `/login?next=${currentPath}`;
      return Promise.reject("没有找到 Token，请重新登录");
    }
    try {
      const tokenParts = token.split(".");
      if (tokenParts.length !== 3) {
        throw new Error("Token 格式不正确");
      }
      const payload = tokenParts[1];
      const decodedPayload = JSON.parse(
        // 特殊字符处理 解决非 ASCII 字符或转义字符 parse 报错
        decodeURIComponent(
          atob(payload)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(""),
        ),
      );

      // exp 时间戳
      const exp = decodedPayload.exp;
      const currentTime = Math.floor(Date.now() / 1000);
      // Token 是否过期
      if (exp < currentTime) {
        window.location.href = `/login?next=${currentPath}`;
        localStorage.clear();
        Message.error("Token 已过期，请重新登录");
        return Promise.reject("Token 已过期，请重新登录");
      } else {
        config.headers["Token"] = `${token}`;
        if (window.electron) {
          config.headers["Device"] = "web_client";
        }
        return config;
      }
    } catch (error) {
      window.location.href = `/login?next=${currentPath}`;
      Message.error("Token 无效，请重新登录");
      localStorage.clear();
      return Promise.reject("Token 无效，请重新登录");
    }
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    if (response.config.url.includes("graphql")) {
      if (response.data.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response.data.message);
      }
    }
    if (response.headers["content-type"] === "text/event-stream") {
      return Promise.resolve(response.data);
    }
    if (response.status === 200 || response.status === 207) {
      if (response.data.code === 0) {
        return Promise.resolve(response.data);
      } else {
        console.log(response?.data?.message, "err");
        Message.error(response?.data?.message);
        return Promise.reject(response.data.message);
      }
    }
    return Promise.reject("请求失败");
  },
  (error) => {

    if (error.response && error.response.status === 401) {
      window.localStorage.clear();
      window.location.href = `/login?next=${window.location.pathname + window.location.search}`;
      return;
    }
    if (error.response && error.response.status === 400) {
      return Promise.reject(error.response.data.message);
    }

    return Promise.reject(error);
  },
);

export default http;

export const getApi = (
  url: string,
  params = {},
  isArray = false,
): Promise<any> => {
  return http({
    url,
    method: "GET",
    params,
    paramsSerializer: isArray
      ? (params) => {
        return qs.stringify(params, { indices: false });
      }
      : undefined,
  });
};

export const postApi = (url: string, data = {}, params = {}): Promise<any> => {
  return http({
    url,
    method: "post",
    data,
    params,
  });
};

export const putApi = (url: string, data = {}, params = {}): Promise<any> => {
  return http({
    url,
    method: "put",
    data,
    params,
  });
};
export const graphApi = (url: string, data = ""): Promise<any> => {
  return http.post(url, data, {
    headers: {
      "Content-type": "application/graphql",
    },
  });
};
export const deleteApi = (
  url: string,
  data = {},
  params = {},
): Promise<any> => {
  return http({
    url,
    method: "delete",
    data,
    params,
  });
};
